import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { ContentActionsService } from '~commonInfra/contentActions/ContentActions';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { IDataSourceDetailInfo } from '~src/datasource/models/IDataSourceInfo';

import { NewPublishedDatasourceFromDatasourceAction } from '../actions/NewPublishedDatasourceFromDatasourceAction';
import { IContentInfo } from '../models/IContentInfo';
import { getDatasourceDetailInfo, openBlankWindow, replaceDatasourceIdWithConnectionIdForMixedContent, setWindowLocation } from './SpacesSagaHelpers';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in this saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards.

export function* handleNewPublishedDatasourceFromDatasourceAction(action: NewPublishedDatasourceFromDatasourceAction): SagaIterator {
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    if (!newWindow) {
      yield put(requestFailed(new Error('Popup blocked'), Messages.errorUnknown()));
      return;
    }
    const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
    const content: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.datasource]);
    const datasource: IDataSourceDetailInfo = yield call(getDatasourceDetailInfo, content[0].id);
    const url = ContentActionsService.generateTempWorkbookForCreateDatasource(
      siteUrlName,
      datasource.project?.id || action.projectId || '',
      datasource
    );
    setWindowLocation(newWindow, url);
  } catch (e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
